import { useState } from "react";

export interface FaqItem {
  q: string;
  a: string;
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer group"
              >
                <span className="flex items-start gap-3">
                  <span className="mt-0.5 w-6 h-6 shrink-0 rounded-md bg-primary-100 text-primary-700 text-xs font-semibold flex items-center justify-center">
                    Q
                  </span>
                  <span className="font-heading font-semibold text-base md:text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.q}
                  </span>
                </span>
                <span
                  className={`w-8 h-8 shrink-0 rounded-md border flex items-center justify-center transition-colors ${
                    isOpen
                      ? "bg-primary-500 border-primary-500 text-background-50"
                      : "border-background-300 text-foreground-600"
                  }`}
                >
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="pb-6 pl-9 pr-2">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}